<form
    [formGroup]="form"
    *yssIsLoading="subFormIsLoading$ | async">
    <div class="row">
        <div class="col-12">
            <app-user-multi-select-area
                [preselectedUserIds]="this.action.taggedAdminsIds"
                [title]="'Tag Admin Users:'"
                (usersSelected)="adminSelected($event)"></app-user-multi-select-area>
        </div>
    </div>

    <div
        class="row"
        *ngIf="form.controls.labels">
        <div class="col-12">
            <app-label-selector-area
                [labelControl]="form.controls.labels"
                [labelType]="ELabelType.Action"
                [entityId]="action.id"></app-label-selector-area>
        </div>
    </div>
    <app-user-select-or-create
        [form]="form"
        [selectedUser]="action.customer"></app-user-select-or-create>
    <div class="row">
        <div class="col-12">
            <label class="padded-top-gray-label">Description:</label>
            <textarea
                class="textarea-styled"
                rows="4"
                placeholder="Enter Action Description"
                formControlName="description"></textarea>
        </div>
    </div>
</form>
